import { QuizQuestion } from "../../shared/types";
import {
  Language,
  CloudSync,
  Chat,
  Event,
  SmartToy,
  Build,
  Autorenew,
  TrendingUp,
  Groups,
  Monitor,
  Computer,
  Wifi,
  MenuBook,
  LibraryBooks,
  Assignment,
  Psychology,
  Security,
  VpnKey,
  Shield,
  AdminPanelSettings,
  Analytics,
  BarChart,
  Dashboard,
  PsychologyAlt,
  CloudUpload,
  Settings,
  Architecture,
  PersonAdd,
  Checklist,
  School,
  AutoAwesome,
  AttachMoney,
  Speed,
  Insights,
  Timeline,
  Hub,
  PersonOff,
  SupportAgent,
  Money,
} from "@mui/icons-material";

export const workplaceQuestions: QuizQuestion[] = [
  {
    question: "How does your team currently collaborate on projects and share information?",
    options: [
      { text: "We have integrated digital tools that work seamlessly together", icon: Language },
      { text: "We use some tools but they don't connect well", icon: CloudSync },
      { text: "Mostly email and scattered file sharing", icon: Chat },
      { text: "We rely heavily on in-person meetings and phone calls", icon: Event },
    ],
  },
  {
    question: "How much time does your team spend on repetitive, manual tasks each day?",
    options: [
      { text: "Very little — most routine work is automated", icon: SmartToy },
      { text: "Some manual work, but it's manageable", icon: Build },
      { text: "A significant amount — it slows us down", icon: Autorenew },
      { text: "Most of our day is spent on repetitive tasks", icon: TrendingUp },
    ],
  },
  {
    question: "Can your team access company data and work effectively from anywhere?",
    options: [
      { text: "Yes — full remote capability with secure access", icon: Groups },
      { text: "Mostly, but some limitations or security concerns", icon: Monitor },
      { text: "Limited — we can do basic tasks remotely", icon: Computer },
      { text: "No — we need to be in the office to be productive", icon: Wifi },
    ],
  },
  {
    question: "How organized and searchable is your company's digital information?",
    options: [
      { text: "Very organized — we can find anything instantly", icon: MenuBook },
      { text: "Somewhat organized — takes a bit of searching", icon: LibraryBooks },
      { text: "Poorly organized — we waste time looking for things", icon: Assignment },
      { text: "Total chaos — information is everywhere and nowhere", icon: Psychology },
    ],
  },
  {
    question: "How secure do you feel your business data and systems are?",
    options: [
      { text: "Very secure — we have comprehensive protection", icon: Security },
      { text: "Fairly secure — basic protections in place", icon: VpnKey },
      { text: "Somewhat worried — we know we have gaps", icon: Shield },
      { text: "Very concerned — we haven't addressed security properly", icon: AdminPanelSettings },
    ],
  },
  {
    question: "When your team needs to make decisions, how quickly can you access the information you need?",
    options: [
      { text: "Instantly — everything is at our fingertips", icon: Analytics },
      { text: "Usually within a few hours of searching", icon: BarChart },
      { text: "It takes days to gather what we need", icon: Dashboard },
      { text: "We often make decisions without complete information", icon: PsychologyAlt },
    ],
  },
  {
    question: "How well do your current digital tools scale with your business growth?",
    options: [
      { text: "Perfectly — they grow with us automatically", icon: Build },
      { text: "Pretty well — we occasionally need upgrades", icon: CloudUpload },
      { text: "Not well — we outgrow tools quickly", icon: Settings },
      { text: "Terribly — we're constantly hitting limits", icon: Architecture },
    ],
  },
  {
    question: "What happens when team members leave or new people join?",
    options: [
      { text: "Smooth transition — knowledge and access transfer easily", icon: PersonAdd },
      { text: "Some bumps but manageable with documentation", icon: Checklist },
      { text: "Stressful — lots of knowledge walks out the door", icon: School },
      { text: "Chaos — we lose important information and access", icon: AutoAwesome },
    ],
  },
  {
    question: "How much does your current technology setup cost relative to the value it provides?",
    options: [
      { text: "Great ROI — technology clearly pays for itself", icon: AttachMoney },
      { text: "Decent value — worth the investment", icon: Speed },
      { text: "Questionable — not sure if we're getting our money's worth", icon: Insights },
      { text: "Expensive burden — feels like we're overpaying for what we get", icon: Timeline },
    ],
  },
  {
    question: "What's your biggest workplace technology frustration right now?",
    options: [
      { text: "Tools don't talk to each other — too many silos", icon: Hub },
      { text: "Team spends too much time on manual, repetitive work", icon: PersonOff },
      { text: "Can't work effectively outside the office", icon: SupportAgent },
      { text: "Information is scattered and hard to find", icon: Money },
    ],
  },
];
